import React, { Component } from "react";
import axios from "axios";
import api from "../common/api";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import { Container, Row, Col } from "shards-react";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { userHasRole } from "../auth/UserFunctions";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "0",
    marginRight: "12px",
    padding: "0"
  },
  menu: {
    fontSize: "0.75rem"
  },
  tableCell: {
    padding: "0px 6px",
    width: "90px"
  }
});

class CuitVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      snackbar: { open: false, severity: "" },
      contact: { taxes: {} },
      captcha: { url: "", code: "", bar: "" },
      loading: true
    };
  }

  async componentDidMount() {
    var contact_id = this.props.contact_id
      ? this.props.contact_id
      : this.props.match.params.contact_id;
    await this.getContact(contact_id);
  }

  getContact = id => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.contacts().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var contact = this.state.contact;
        contact = res.data;
        contact.taxes.document_number = contact.taxes.document_number.replaceAll(
          "-",
          ""
        );
        this.setState({ contact: contact, loading: false });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getCaptcha = cuit => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.contacts().getAfipCaptcha(cuit), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var captcha = this.state.captcha;
        captcha = res.data;
        this.setState({ captcha: captcha, loading: false });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleChange = e => {
    e.preventDefault();
    var captcha = this.state.captcha;
    captcha.code = e.target.value;
    this.setState({ captcha: captcha });
  };

  handleSnackbar = e => {
    e.preventDefault();
    var snackbar = this.state.snackbar;
    snackbar.open = !snackbar.open;
    this.setState({ snackbar: snackbar });
  };

  handleValidateCuitValidation = e => {
    e.preventDefault();
    var contact = this.state.contact;
    var cuit = this.state.contact.taxes.document_number;
    var code = this.state.captcha.code;
    var bar = this.state.captcha.bar;

    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .get(
        api
          .contacts()
          .validateAfipCaptcha(cuit, code, bar, this.state.contact.id),
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(res => {
        var contact = this.state.contact;
        contact.afip_voucher = res.data;
        this.setState({ contact: contact });
      })
      .catch(function(error) {
        var error_message = "Ha ocurrido un error. Contacte a su administrador";
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
      });
  };

  handleSubmit = e => {
    e.preventDefault();
    var formData = new FormData();
    var contact = this.state.contact;
    formData.set("contact_id", this.state.contact.id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.contacts().updateCuitVerificationDate(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = this.state.snackbar;
        snackbar.open = true;
        snackbar.severity = "success";
        snackbar.success_message = "Fecha actualizada con éxito";
        this.setState({ snackbar: snackbar });
      })
      .catch(function(error) {
        var error_message = "Ha ocurrido un error. Contacte a su administrador";
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
      });
  };

  render() {
    const classes = this.props.classes;
    return (
      <React.Fragment>
        <Container
          fluid
          className="main-content-container px-4 position-relative"
        >
          {this.state.loading !== true ? (
            <React.Fragment>
              <div className="row col-12 mt-2 ml-2">
                <Snackbar
                  open={this.state.snackbar.open}
                  onClose={this.handleSnackbar}
                >
                  <Alert
                    onClose={this.handleSnackbar}
                    severity={this.state.snackbar.severity}
                  >
                    {this.state.snackbar.success_message}
                  </Alert>
                </Snackbar>
              </div>
              <div className="row col-12 mt-2 ">
                <TextField
                  id="name"
                  value={this.state.contact.hansa_name}
                  disabled={true}
                  type="text"
                  required
                  name="name"
                  margin="normal"
                  className="m-0 p-0 mr-2 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 100 }}>
                          Contacto
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
                />
                <TextField
                  id="name"
                  value={this.state.contact.taxes.document_number}
                  disabled={true}
                  type="text"
                  required
                  name="name"
                  margin="normal"
                  className="m-0 p-0 mr-2 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 50 }}>
                          CUIT
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 120, fontSize: "0.75rem" } }}
                />
                <TextField
                  id="cuit_date_verification"
                  value={this.state.contact.taxes.cuit_date_verification}
                  disabled={true}
                  type="text"
                  required
                  name="cuit_date_verification"
                  margin="normal"
                  className="m-0 p-0 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 100 }}>
                          Fecha hasta
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 120, fontSize: "0.75rem" } }}
                />
              </div>
              {this.state.captcha.url !== "" ? (
                <React.Fragment>
                  <div className="mt-2">
                    <img src={this.state.captcha.url} />
                  </div>
                  <div className="mt-1">
                    <TextField
                      id="code"
                      placeholder="Ingerse el código de verificación"
                      value={this.state.captcha.code}
                      onChange={this.handleChange}
                      type="text"
                      required
                      name="code"
                      margin="normal"
                      className="m-0 p-0 mr-2 mt-2"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography
                              variant="caption"
                              style={{ width: 100 }}
                            >
                              Código
                            </Typography>
                          </InputAdornment>
                        )
                      }}
                      inputProps={{
                        style: { minWidth: 200, fontSize: "0.75rem" }
                      }}
                    />
                    {/*(this.state.contact.afip_voucher) 
											?
												<Button variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {this.handleSubmit(e)}}>Actualizar Fecha</Button>
											:
												''
										*/}
                  </div>
                  {this.state.contact.afip_voucher ? (
                    <React.Fragment>
                      <div className="row col-8 mt-2 overflow-auto h-5 mx-auto">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.contact.afip_voucher
                          }}
                        />
                      </div>
                      {userHasRole("web-afip-validator") && (
                        <div>
                          <Button
                            className="mt-2"
                            variant="contained"
                            color="primary"
                            size="small"
                            style={{ fontSize: "0.75rem" }}
                            onClick={e => {
                              window.location.href =
                                "/contact/update-verification-date/" +
                                this.state.contact.id;
                            }}
                          >
                            Actualizar manualmente
                          </Button>
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                    <Button
                      className="mt-2"
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ fontSize: "0.75rem" }}
                      onClick={e => {
                        this.handleValidateCuitValidation(e);
                      }}
                    >
                      Validar CUIT
                    </Button>
                  )}
                </React.Fragment>
              ) : (
                <div className="row col-12 mt-2">
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ fontSize: "0.75rem" }}
                    onClick={e => {
                      this.getCaptcha(this.state.contact.taxes.document_number);
                    }}
                  >
                    Generar Captcha
                  </Button>
                </div>
              )}
            </React.Fragment>
          ) : (
            ""
          )}
        </Container>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(CuitVerification);
